"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderLineVersion = void 0;
const cloneObject_1 = require("../cloneObject");
const updateOrderLineVersion = async (supabase, order_line_version) => {
    const obj = (0, cloneObject_1.cloneObject)(order_line_version);
    delete obj.id;
    delete obj.created_at;
    delete obj.regions;
    delete obj.order_lines;
    const { data, error } = await supabase
        .from("order_line_versions")
        .insert(obj)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.updateOrderLineVersion = updateOrderLineVersion;
